import React, { Component } from 'react';
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import UserAccess from './UserAccess';
import DeletePortfolio from './DeletePortfolio';
import './DetailsModal.css';

class DetailsModal extends Component {  

  render() {
    const { showDetailsModal, closeModal } = this.props;

    return (
      <Modal show={showDetailsModal} onHide={() => closeModal('showDetailsModal')} id="details-modal">
        <Modal.Body>
          <Tabs defaultActiveKey={1} id="details-tabs">
            <Tab eventKey={1} title="Access">
              <UserAccess />
            </Tab>
            <Tab eventKey={2} title="Remove">
              <DeletePortfolio 
                closeModal={() => closeModal('showDetailsModal')} />
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default"  
            onClick={() => closeModal('showDetailsModal')}
          >Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DetailsModal;